"use client"

import * as React from "react"

import { cn } from "../../lib/utils"
import { ProfileAvatar } from "./profile-avatar"

export interface ApplicationStatusCardProps {
  className?: string
  status: string
  statusColor?: string
  reviewer?: {
    name: string
    avatar?: string
  }
  eta?: string
}

function ApplicationStatusCard({
  className,
  status,
  statusColor = "text-[#ED5AA9]",
  reviewer,
  eta,
}: ApplicationStatusCardProps) {
  return (
    <div
      className={cn(
        "bg-white border border-black rounded-lg overflow-hidden shadow-[0px_4px_0px_0px_#000000]",
        className
      )}
    >
      {/* Title */}
      <div className="px-4 py-3 border-b border-gray-100">
        <h3 className="text-sm font-semibold text-[#344054]">Application Status</h3>
      </div>

      {/* Status Row */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <span className="text-sm text-[#667085]">Status:</span>
        <span className={cn("text-sm font-medium", statusColor)}>{status}</span>
      </div>

      {/* Reviewer Row */}
      {reviewer && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <span className="text-sm text-[#667085]">Reviewer:</span>
          <div className="flex items-center gap-2">
            <ProfileAvatar
              src={reviewer.avatar}
              alt={reviewer.name}
              className="h-6 w-6 rounded-full"
              fallbackClassName="bg-gray-100"
              logoClassName="h-[56%] w-[56%]"
            />
            <span className="text-sm font-medium text-[#344054]">{reviewer.name}</span>
          </div>
        </div>
      )}

      {/* ETA Row */}
      {eta && (
        <div className="flex items-center justify-between px-4 py-3">
          <span className="text-sm text-[#667085]">ETA:</span>
          <span className="text-sm font-medium text-[#344054]">{eta}</span>
        </div>
      )}
    </div>
  )
}

export { ApplicationStatusCard }
